import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CustomerJobScreenJob,
  JobScreenDriverDetailsJob,
  JobScreenDriverNotesJob,
  JobScreenImageGalleryJob,
  JobScreenSiteOpeningJob,
  SupplierJobScreenJob,
  VMEJobScreenDatesPricesJob,
  VMEJobScreenJob,
} from '../../../interfaces/screen-specific/job-screen';
import { JobStatus } from '../../../enums/job-status';
import { UserService } from '../../../services';
import { MessageService } from 'primeng';
import { IJobScreen } from '../../../interfaces/job/job';
import { OrganisationTypeEnum } from '../../../enums/organisation-types';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class JobScreenCommonService {
  constructor(
    public http: HttpClient,
    private userService: UserService,
    private router: Router,
    private messageService: MessageService,
  ) {}

  getStatusCode(job: VMEJobScreenJob | CustomerJobScreenJob | SupplierJobScreenJob): string {
    return this.getStatus(job).toLowerCase().replace(' ', '-');
  }

  isJobCompleted(
    job: JobScreenDriverDetailsJob | JobScreenDriverNotesJob | JobScreenSiteOpeningJob,
  ): boolean {
    if (!job) {
      return false;
    }

    return (
      job.statusId == JobStatus.Completed ||
      job.statusId == JobStatus.Cancelled ||
      job.statusId == JobStatus.Closed
    );
  }

  isJobStatusCompleted(jobStatusId): boolean {
    return (
      jobStatusId == JobStatus.Completed ||
      jobStatusId == JobStatus.Cancelled ||
      jobStatusId == JobStatus.Closed
    );
  }

  isJobCancelled(job: JobScreenImageGalleryJob): boolean {
    if (!job) {
      return false;
    }

    return job.statusId == JobStatus.Cancelled;
  }

  isJobClosed(job: IJobScreen | VMEJobScreenDatesPricesJob): boolean {
    if (!job) {
      return false;
    }

    return job.statusId == JobStatus.Cancelled || job.statusId == JobStatus.Closed;
  }

  canShowPriceDetails(job: VMEJobScreenJob | VMEJobScreenDatesPricesJob | SupplierJobScreenJob) {
    return (
      job != null &&
      (job.statusId == JobStatus.Closed ||
        job.statusId == JobStatus.Cancelled ||
        job.statusId == JobStatus.Paused ||
        job.statusId == JobStatus.Completed ||
        job.statusId == JobStatus.Started ||
        job.statusId == JobStatus.Cancelled)
    );
  }

  getStatus(job: VMEJobScreenJob | CustomerJobScreenJob | SupplierJobScreenJob): string {
    if (job == null) {
      return '';
    }

    if (job.statusId == JobStatus.Created) {
      let now = new Date();
      let heldEndDate = new Date();
      let exisingCapacityEndDate = new Date();
      let scheduledDate = new Date();

      if (typeof job.heldEndDate == 'string') {
        heldEndDate = new Date(job.heldEndDate);
      } else {
        heldEndDate = job.heldEndDate;
      }

      if (typeof job.exisingCapacityEndDate == 'string') {
        exisingCapacityEndDate = new Date(job.exisingCapacityEndDate);
      } else {
        exisingCapacityEndDate = job.exisingCapacityEndDate;
      }

      if (now < heldEndDate) {
        return 'Held';
      } else if (now >= heldEndDate && now < exisingCapacityEndDate) {
        return 'Existing Capacity';
      } else if (now >= exisingCapacityEndDate) {
        return 'Buy It Now';
      }
    }

    switch (job.statusId) {
      case JobStatus.Completed:
        return 'Completed';
      case JobStatus.Invoiced:
        return 'Invoiced';
      case JobStatus.Closed:
        return 'Closed';
      case JobStatus.Cancelled:
        return 'Cancelled';
      case JobStatus.Started:
        return 'Started';
      case JobStatus.Paused:
        return 'Paused';
    }

    return '';
  }

  impersonateUser(userId: string) {
    let obj = {
      ImpersonatedUserGUID: userId,
      ImpersonatedUserName: '',
      OriginalUserName: '',
      IsImpersonating: false,
    };
    this.userService.impersonateUser(obj).then(() => {
      window.location.reload();
      window.location.href = '/';
    });
  }

  goToPriceDetails(
    organisationTypeId: number,
    job: VMEJobScreenDatesPricesJob | SupplierJobScreenJob,
    order?: any,
  ) {
    let param: any = {
      jobId: job.id,
    };

    const hasOrders =
      (job as any).orders && Array.isArray((job as any).orders) && (job as any).orders.length > 0;

    if (order == null && hasOrders) {
      order = (job as any).orders[0];
    }

    if (organisationTypeId == OrganisationTypeEnum.Engineius) {
      if (order) {
        param.orderId = order.id;
        param.customerId = order.customerId;
      }

      if (job.supplierId) {
        param.supplierId = job.supplierId;
      }
    }

    if (organisationTypeId == OrganisationTypeEnum.Customer) {
      if (order) {
        param = {
          orderId: order.id,
        };
      }
    }

    this.router.navigate(['app/pricedetails'], { queryParams: param }).then();
  }
}
